import React from 'react';
import { Link } from "react-router-dom";
import { cn } from '@/lib/utils';

type NavItemProps = {
  icon: React.ElementType;
  label: string;
  to: string;
  isActive?: boolean;
  isPermanentActive?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  badge?: string;
};

export const NavItem = ({
  icon: Icon,
  label,
  to,
  isActive = false,
  isPermanentActive = false,
  onClick,
  badge
}: NavItemProps) => {
  const active = isActive || isPermanentActive;

  const isButton = to === '#' && onClick;

  const classes = cn(
    "relative flex items-center gap-[10px] rounded-[10px] group w-full",
    "text-[14px] leading-tight bg-transparent hover:bg-transparent",
    "transition-colors duration-[160ms] ease-out",
    "outline-none ring-0 border-none shadow-none",
    "focus:outline-none focus:ring-0 focus:border-none focus:shadow-none",
    "focus-visible:outline-none focus-visible:ring-0 focus-visible:border-none focus-visible:shadow-none",
    "active:outline-none active:ring-0 active:border-none",
    "min-h-[40px] py-[5px] px-[8px]",
    "[&:focus]:outline-none [&:focus-visible]:outline-none",
    active
      ? "font-semibold text-[#2F6FED]"
      : "font-medium text-[#475467] hover:text-[#3B73E8]"
  );

  const content = (
    <>
      {/* Chip do ícone — sinaliza o item ativo (a linha permanece transparente) */}
      <span
        className={cn(
          "flex items-center justify-center w-[30px] h-[30px] rounded-[9px] flex-shrink-0 border",
          "transition-colors duration-[160ms] ease-out",
          active
            ? "bg-[#EEF4FF] border-[#C9DBFF]"
            : "bg-[#F5F7FA] border-transparent group-hover:bg-[#F4F7FF] group-hover:border-[#E0E9FF]"
        )}
      >
        <Icon
          strokeWidth={2}
          className={cn(
            "h-[17px] w-[17px] transition-colors duration-[160ms] ease-out",
            active ? "text-[#2F6FED]" : "text-[#667085] group-hover:text-[#3B73E8]"
          )}
        />
      </span>

      <span className="flex-1 text-left">{label}</span>

      {badge && (
        <span className="px-2 py-0.5 text-[10px] font-semibold bg-[#2563FF] text-white rounded-full">
          {badge}
        </span>
      )}
    </>
  );

  if (isButton) {
    return (
      <button
        type="button"
        className={classes}
        style={{ textAlign: 'left', appearance: 'none' }}
        onClick={onClick}
      >
        {content}
      </button>
    );
  }

  return (
    <Link to={to} className={classes} onClick={onClick}>
      {content}
    </Link>
  );
};
